<template>
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">
        <i :class="'fas ' + icon" :style="{color: color}" />
        <slot name="header" />
      </h3>
      <div class="card-tools" />
    </div>
    <div class="card-body">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardPanel',
  props: {
    icon: {
      type: String,
      default: 'fa-chart-pie'
    },
    color: {
      type: String,
      default: '#6c757d'
    }
  }
}
</script>
